<template>
  <div ref="wall" class="masonry-wall" :style="{ gap: `${gap}px` }">
    <div v-for="(column, columnIndex) in columns" :key="columnIndex" class="masonry-column" :data-index="columnIndex"
      :style="{
        display: 'flex',
        'flex-basis': 0,
        'flex-direction': 'column',
        'flex-grow': 1,
        height: ['-webkit-max-content', '-moz-max-content', 'max-content'],
        gap: `${gap}px`,
      }">
      <div v-for="itemIndex in column" :key="itemIndex" class="masonry-item">
        <slot :item="items[itemIndex]" :index="itemIndex">
          {{ items[itemIndex] }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  columnWidth: 400,
  items: {
    type: Array,
    default: []
  },
  gap: 0,
  rtl: false,
  ssrColumns: 0,
});

const { columnWidth, items, gap, rtl, ssrColumns } = toRefs(props)
const columns = ref([])
const wall = ref()

const { width, height } = useWindowSize()

// const wallWidth = wall.value?.getBoundingClientRect().width || 1080
// const wallWidth = wall.value.getBoundingClientRect().width
const emit = defineEmits(['redraw', 'redraw-skip']);

function columnCount() {
  // const count = Math.floor(
  //   (wall.value.getBoundingClientRect().width + gap.value) /
  //   (columnWidth.value + gap.value)
  // )
  // return count > 0 ? count : 1
  return width.value >= 800 ? 3 : 1
}

const distributeImages = (images, columns) => {
  const heights = Array(columns).fill(0); // 初始化列高度
    const columnIndices = Array.from({ length: columns }, () => []); // 初始化二维数组
    images.forEach((imageHeight) => {
        // 找到当前高度最短的列索引
        const minHeightIndex = heights.indexOf(Math.min(...heights));
        // 更新该列的高度
        heights[minHeightIndex] += imageHeight.ratioHeight;
        // 记录当前图片的列索引到对应的列
        columnIndices[minHeightIndex].push(images.indexOf(imageHeight));
    });
    return columnIndices; // 返回每列的索引数组
};

function createColumns(count) {
  return [...new Array(count)].map(() => [])
}

if (ssrColumns.value > 0) {
  // const newColumns = createColumns(ssrColumns.value)
  // items.value.forEach((_, i) =>
  //   newColumns[i % ssrColumns.value].push(i)
  // )
  const newColumns = distributeImages(items.value, ssrColumns.value);
  columns.value = newColumns
}

async function fillColumns(itemIndex) {
  if (itemIndex >= items.value.length) {
    return
  }
  await nextTick()
  const columnDivs = [...wall.value?.children]
  if (rtl.value) {
    columnDivs.reverse()
  }
  const target = columnDivs.reduce((prev, curr) =>
    curr.getBoundingClientRect().height < prev.getBoundingClientRect().height
      ? curr
      : prev
  )
  columns.value[+target.dataset.index].push(itemIndex)
  await fillColumns(itemIndex + 1)
}

async function redraw(force = false) {
  if (columns.value.length === columnCount() && !force) {
    emit('redraw-skip')
    return
  }

  columns.value = createColumns(columnCount())
  const scrollY = window.scrollY
  await fillColumns(0)
  window.scrollTo({ top: scrollY })
  emit('redraw')
}

useResizeObserver(wall, (entries) => {
  redraw()
})
// const resizeObserver = new ResizeObserver(() => redraw())

// onMounted(() => {
//   redraw()
//   resizeObserver.observe(wall.value)
// })

// onBeforeUnmount(() => resizeObserver.unobserve(wall.value))

watch([items, rtl], () => redraw(true))
watch([columnWidth, gap], () => redraw())
</script>
